"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultCountryForBrand = void 0;
const types_1 = require("../types");
/**
 * Determine the default country value for a Brand.
 *
 * @param {Brand} brand
 * The Brand.
 *
 * @returns {IsoCountryCode2Char}
 * The default 2-character ISO country code for the Brand.
 */
const getDefaultCountryForBrand = (_brand) => types_1.IsoCountryCode2Char.US;
exports.getDefaultCountryForBrand = getDefaultCountryForBrand;
//# sourceMappingURL=brand.js.map